define('ch_intl',[],function() {
    if (!window.Intl) {
        // otherwise require & load the polyfill
        require(['intl_polyfill'], function(Intl) {
            window.Intl = Intl;
        });
    }
    return window.Intl;
});

